import type { ReactNode } from 'react';

import { PortalFadeIn } from '@/modules/portal/components/ui/portal-motion';
import { cn } from '@/shared/lib/cn';

interface PortalPageProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function PortalPage({ title, description, actions, children, className }: PortalPageProps) {
  return (
    <div className={cn('space-y-8', className)}>
      <PortalFadeIn>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            <h1 className="portal-page-title">{title}</h1>
            {description ? <p className="portal-page-description">{description}</p> : null}
          </div>
          {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      </PortalFadeIn>
      {children}
    </div>
  );
}
